// extracted by mini-css-extract-plugin
export default {"sectionsList":"CardsList_sectionsList__lfcnB"};